<Title name={titleName} settingsPage={true} />

<LazyPage {pageComponent} {params} />

<script>
  import Title from '../../_components/Title.html'
  import LazyPage from '../../_components/LazyPage.html'
  import pageComponent from '../../_pages/settings/instances/add.html'

  export default {
    components: {
      Title,
      LazyPage
    },
    data: () => ({
      pageComponent
    }),
    computed: {
      titleName: ({ $isUserLoggedIn }) => $isUserLoggedIn ? "Add instance" : "Log in"
    }
  }
</script>
